module.exports = __webpack_public_path__ + "static/media/ITW-logo.0ce3209e.svg";